<template>
  <div class="app-bar-menu-locale">
    <v-menu location="right" min-width="400">
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props">
          <template v-slot:prepend>
            <v-icon>mdi-translate</v-icon>
          </template>

          <v-list-item-title
            >{{ $t('labels.language') }}
            <span class="text-uppercase"> ({{ $vuetify.locale.current }}) </span>
          </v-list-item-title>
          <template v-slot:append>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-list-item>
      </template>
      <v-list :v-model:selected="currentLocaleValue">
        <v-list-item
          v-for="item in langs"
          :key="item"
          :value="item"
          v-on:click="changeLocale(item)"
          :title="$t('languages.' + item)"
        >
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'MenuItemLocale',
  mixins: [utils],
  data() {
    return {
      langs: this.loadLocaleLanguages(),
      currentLocale: '',
    }
  },
  computed: {
    currentLocaleValue() {
      return this.langs.indexOf(this.currentLocale)
    },
  },
  methods: {
    changeLocale(value) {
      this.setLocale(value)
    },
    loadLocaleLanguages() {
      // Use import.meta.glob to find all language files
      const localeFiles = import.meta.glob('@/locales/*.json', { eager: true })
      return Object.keys(localeFiles)
        .map((path) => {
          // Extract the language name from the path (e.g. en from /src/locales/en.json)
          const match = path.match(/([A-Za-z0-9-_]+)\.json$/)
          return match ? match[1] : null
        })
        .filter(Boolean)
    },
  },
}
</script>
